import { CanMatchFn, Routes } from '@angular/router';
import { WelcomeComponent } from './pages/support/welcome/welcome.component';
import { LoginComponent } from './pages/login/login/login.component';
import { AccountInactiveComponent } from './pages/login/account-inactive/account-inactive.component';
import { AuthCallbackComponent } from './pages/login/auth-callback/auth-callback.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { authGuard } from './security/role-guard.service';

const matchFirstSegment = (paths: readonly string[]): CanMatchFn => {
  const pathSet = new Set(paths);

  return (_route, segments) => {
    const firstSegment = segments[0]?.path;
    return !!firstSegment && pathSet.has(firstSegment);
  };
};

const ADMIN_PATHS = [
  'account-management',
  'email-management',
  'user-management',
  'faq-management',
  'agency-report',
  'program-report',
  'program-report-custom',
  'user-report',
  'program-referrals-report',
  'juvenile-programs-report',
  'statistics-report',
] as const;

const REFERRAL_PATHS = [
  'all-referrals-view',
  'weekly-reporting',
  'access-probationer',
  'probationer',
] as const;

const ACCOUNT_PATHS = [
  'status',
  'agency-wizard',
  'agency-info',
  'moa',
  'insurance',
  'mou',
  'programs',
  'program-edit',
  'users',
] as const;

const SUPPORT_PUBLIC_PATHS = [
  'about',
  'getting-started',
  'faq',
  'contact-us',
  'contact-us-success',
  'help-program',
  'help-user',
  'new-account',
  'new-account-success',
] as const;

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: WelcomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'account-inactive', component: AccountInactiveComponent },
  { path: 'auth/callback', component: AuthCallbackComponent },
  {
    path: '',
    canMatch: [matchFirstSegment(SUPPORT_PUBLIC_PATHS)],
    loadChildren: () =>
      import('./routes/support-auth.routes').then(m => m.SUPPORT_AUTH_ROUTES),
  },
  {
    path: '',
    canMatch: [authGuard, matchFirstSegment(ACCOUNT_PATHS)],
    loadChildren: () =>
      import('./routes/account.routes').then(m => m.ACCOUNT_ROUTES),
  },
  {
    path: '',
    canMatch: [authGuard, matchFirstSegment(REFERRAL_PATHS)],
    loadChildren: () =>
      import('./routes/referral.routes').then(m => m.REFERRAL_ROUTES),
  },
  {
    path: '',
    canMatch: [authGuard, matchFirstSegment(ADMIN_PATHS)],
    loadChildren: () =>
      import('./routes/admin.routes').then(m => m.ADMIN_ROUTES),
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '404', pathMatch: 'full' },
];
